import { combineReducers } from 'redux'
import { call, put, takeLatest } from 'redux-saga/effects'
import { reportsAPI } from '../../../api/reports'
import { createActions } from '../../factory/actionFactory'
import { START } from '../../../constants/action-postfix'
import { applicantsListReducer } from './list/applicantsListReducer'
import { applicantsLoaderReducer } from './loader/applicantsLoaderReducer'
import { applicantsFormReducer } from './form/applicantsFormReducer'

export const APPLICANTS_REQUEST = 'APPLICANTS_REQUEST'
export const APPLICANT_DELETE_REQUEST = 'APPLICANT_DELETE_REQUEST'
export const SET_APPLICANTS_FORM_DATA = 'SET_APPLICANTS_FORM_DATA'

export const applicantsReducer = combineReducers({
  list: applicantsListReducer,
  loader: applicantsLoaderReducer,
  form: applicantsFormReducer,
})

export const applicantsActions = createActions('applicants', APPLICANTS_REQUEST)
export const applicantDeleteActions = createActions('applicantDelete', APPLICANT_DELETE_REQUEST)
export const setApplicantsFormData = payload => ({ type: SET_APPLICANTS_FORM_DATA, payload })

export function* applicantsWatcher() {
  yield takeLatest(`${APPLICANTS_REQUEST}${START}`, applicantsWorker)
}

export function* applicantDeleteWatcher() {
  yield takeLatest(`${APPLICANT_DELETE_REQUEST}${START}`, applicantDeleteWorker)
}

function* applicantsWorker({ payload }) {
  try {
    const response = yield call(reportsAPI.applicants, payload)
    yield put(applicantsActions.applicantsRequestSuccess(response.data.Answer.Data))
  } catch (error) {
    yield put(applicantsActions.applicantsRequestError(error))
  }
}

function* applicantDeleteWorker({ payload }) {
  try {
    yield call(reportsAPI.applicantDelete, payload)
    yield put(applicantDeleteActions.applicantDeleteRequestSuccess(payload.xp_key))
  } catch (error) {
    yield put(applicantDeleteActions.applicantDeleteRequestError(error))
  }
}
